module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/gxsjtotu.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fgxsjtotu.png
// module id = tYgG
// module chunks = 93